<template>
  <div class="flex-1 flex items-center text-white text-sm">
    <div class="font-semibold">{{ title }}</div>
    <div class="min-w-1 min-h-1 rounded-full bg-o-red mx-1.25"></div>
    <OLink
      v-if="article"
      class="flex-1 line-clamp-1 hover:text-o-red"
      :href="getArticleUrl({ article })"
      v-bind="bind(article)"
      :title="article.title"
      @click="clickDataLayer(article)"
    >
      {{ article.title }}
    </OLink>
  </div>
</template>
<script>
import { computed, defineComponent, onBeforeMount, ref, useContext } from '@nuxtjs/composition-api';
import { useTracking } from '~/modules/tracking/composables/useTracking';
import { getArticleUrl } from '~/modules/common/utils/routingUtils';
import { localStore } from '~/modules/common/utils/localStorageUtils';
import { useDevice } from '~/composables/useDevice';
import { OLink } from '~/modules/common/components/ui';

export default defineComponent({
  props: {},
  components: { OLink },
  setup() {
    const { $service, i18n } = useContext();
    const news = ref([]);
    const isBreakingNews = ref(false);
    onBeforeMount(async () => {
      const breakingNewsLocalStore = await localStore.getItem('o-breaking-news');
      const breakingNewsTypeLocalStore = await localStore.getItem('o-breaking-news-type');

      if (breakingNewsLocalStore) {
        news.value = breakingNewsLocalStore;
        isBreakingNews.value = breakingNewsTypeLocalStore;
      } else {
        try {
          const { data: result, extraData } = await $service.article.getBreakingNews();
          news.value = result;
          isBreakingNews.value = extraData.isBreakingNews;
          localStore.setItem('o-breaking-news', result, { expireMs: 60 }); // 1 mins
          localStore.setItem('o-breaking-news-type', extraData.isBreakingNews, { expireMs: 60 }); // 1 mins
        } catch {
          news.value = ref([]);
        }
      }
      showNextArticle();
    });
    const article = computed(() => news.value[index.value]);
    const title = computed(() => (isBreakingNews.value ? i18n.t('header.breaking-news') : i18n.t('header.whats-going-on')));

    const index = ref(0);
    const showNextArticle = () => {
      setTimeout(() => {
        index.value = (index.value + 1) % news.value.length;
        showNextArticle();
      }, 10000);
    };

    // Data Layer
    const { isMobile } = useDevice();
    const { mapArticleData, getPageType, sendUAGALayers } = useTracking();
    const listName = computed(() => `${getPageType()} - ${isMobile.value ? 'Mobil ' : ''}Siyah Şerit`);

    const clickDataLayer = (article) => {
      const data = mapArticleData('content_click', listName.value, article, index.value + 1);
      sendUAGALayers(data);
    };

    const bind = (article) => {
      const params = {};
      if (article?.redirectUrl) {
        params.rel = 'nofollow';
      }
      return params;
    };

    return { article, title, bind, getArticleUrl, clickDataLayer };
  },
});
</script>
